import { FormControl } from '@angular/forms';
import { required } from '../form-control-options.constants';
import { BaseFormControls } from './base.form-controls';

export class ProductFormControls extends BaseFormControls {
  barcode = new FormControl<string | null>(null);
  product = new FormControl<string | null>(null, required);
}
